import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  Signal
} from '@angular/core';
import { TranslationService } from '@core';
import { SzSegmentedComponent, SzSegmentedOption } from '@ui';

export type DrillsListTab = 'all' | 'favorites' | 'recent';

@Component({
  selector: 'lib-drills-list-tabs',
  templateUrl: './drills-list-tabs.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SzSegmentedComponent]
})
export class DrillsListTabsComponent {
  readonly active: InputSignal<DrillsListTab> = input.required<DrillsListTab>();
  readonly activeChange: OutputEmitterRef<DrillsListTab> = output<DrillsListTab>();

  private readonly translation: TranslationService = inject(TranslationService);

  readonly options: Signal<ReadonlyArray<SzSegmentedOption<DrillsListTab>>> = computed(() => {
    this.translation.translationsLoaded();
    return [
      { label: this.translation.translate('drills.tabs.all'), value: 'all' as DrillsListTab },
      { label: this.translation.translate('drills.tabs.favorites'), value: 'favorites' as DrillsListTab },
      { label: this.translation.translate('drills.tabs.recent'), value: 'recent' as DrillsListTab }
    ];
  });

  onValueChange(value: DrillsListTab): void {
    this.activeChange.emit(value);
  }
}
